import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { mixinRobotoBold, mixinRobotoRegular } from '../../../../styles';
import REsuretyLogo from '../../../../assets/REsurety-logo.svg';

export const AnalyticsStepOneStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }

  .step-one-wrapper {
    overflow: auto;
    display: grid;
    grid-template-columns: 308px 1fr;
    grid-template-rows: calc(50% - 8px) calc(50% - 8px);
    gap: 12px;
    height: calc(100% - 36px);
    padding: 12px;
  }

  .preferences-wrapper {
    grid-area: 1 / 1 / 3 / 2;
    overflow: auto;
  }

  .all-contracts-wrapper {
    grid-area: 1 / 2 / 2 / 3;
  }

  .quadrant-wrapper {
    grid-area: 2 / 2 / 3 / 3;
  }

  .quadrant-wrapper .content-wrapper {
    display: flex;
    flex-direction: row;
    height: 100%;
  }

  .quadrant-wrapper quadrant-spider-chart {
    width: 600px;
  }

  .preferences-wrapper .tab-title {
    font-size: 18px;
    line-height: 56px;
    ${mixinRobotoBold}
  }

  .preferences-wrapper .description {
    padding: 16px;
    font-size: 14px;
    color: var(--nest-level-tab-font);
    ${mixinRobotoRegular};
  }

  .preferences-wrapper .description .explanation {
    font-size: 13px;
    color: var(--primary-color);
    ${mixinRobotoRegular};
  }

  .controls-wrapper {
    padding: 0 16px 40px;
  }

  .controls-wrapper .form-control {
    padding-bottom: 0;
  }

  .controls-wrapper zero-select {
    width: 100%;
    margin-bottom: 5px;
  }

  .card-footer {
    position: relative;
    margin-top: auto;
    border-top: 1px solid var(--border-1);
    background-color: #1a1b1f;
    padding: 11px 16px;
    display: flex;
    gap: 13px;
  }

  .card-footer zero-button {
    width: 50%;
  }

  .card-footer zero-button::part(control) {
    justify-content: flex-start;
  }

  .footer-logo {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 5px;
    top: -30px;
    right: 16px;
    font-size: 11px;
    ${mixinRobotoRegular}
  }

  .resurety-logo {
    background: url(${REsuretyLogo}) no-repeat;
    background-size: contain;
    width: 75px;
    height: 20px;
    display: inline-block;
  }
`;
